import { Chip, FlexContainer, Separator, Spinner, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useGetPlanFlexInfo } from 'Containers/Result/hooks';
import {
  calculateCommission,
  parsePriceFormat,
} from 'Containers/Result/components/PaymentLater/utils';
import * as Styled from './styles';

export const PayLaterInfo = ({ result }: { result: number }): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { data, isLoading } = useGetPlanFlexInfo();
  if (isLoading || !data) {
    return (
      <FlexContainer align="center" justify="center">
        <Spinner size="M" align="center" justify="center" />
      </FlexContainer>
    );
  }

  const resultWithDiscount =
    Math.abs(result) - Number(parsePriceFormat(data?.discountedPrice || data?.price, true));

  const commission = resultWithDiscount * 0.15;
  const amountRecoveredWithCommission = YayoyakiFormatter.formatAmountMxn(
    resultWithDiscount - commission
  );

  return (
    <FlexContainer direction="column" gap="dimension_16" align="center" justify="center">
      <Styled.InfoContainer>
        <FlexContainer fullWidth direction="column" gap="dimension_08">
          <FlexContainer fullWidth align="center" gap="dimension_04" justify="space-between">
            <Text type="paragraphs" color="grey" size="S_M_S">
              {t('InstantRefund.result')}
            </Text>
            <Text type="paragraphs" color="grey" size="S_M_S">
              {YayoyakiFormatter.formatAmountMxn(resultWithDiscount)}
            </Text>
          </FlexContainer>
          <Separator />
          <FlexContainer fullWidth align="center" gap="dimension_04" justify="space-between">
            <Text type="paragraphs" color="grey" size="S_M_S">
              {t('InstantRefund.commission')}
            </Text>
            <Text type="paragraphs" color="grey" size="S_M_S">
              {`- ${calculateCommission(resultWithDiscount)}`}
            </Text>
          </FlexContainer>
          <Separator />
          <FlexContainer fullWidth align="center" gap="dimension_04" justify="space-between">
            <Text type="paragraphs" color="grey" size="S_M_S">
              {t('InstantRefund.time')}
            </Text>
            <Text type="paragraphs" color="grey" size="S_M_S">
              {t('InstantRefund.hours')}
            </Text>
          </FlexContainer>
          <Separator />
          <FlexContainer gap="dimension_04" fullWidth align="baseline" justify="space-between">
            <Text type="paragraphs" size="M_L_S" color="success_strong">
              {t('InstantRefund.receive')}
            </Text>
            <FlexContainer direction="column" align="center" gap="dimension_08">
              <Text type="paragraphs" color="success_strong" size="L_M_S">
                {amountRecoveredWithCommission}
              </Text>
              <Chip size="S" type="success_shaded">
                {t('InstantRefund.sat.info')}
              </Chip>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </Styled.InfoContainer>
    </FlexContainer>
  );
};
